import {PuiCheckbox} from "@portnet/ui";
import React from "react";

const AppCheckBox = React.forwardRef((props, ref) => {
  return <PuiCheckbox ref={ref} {...props} />;
});

export default AppCheckBox;
